const styles = {

  container: (SwxTheme) => {
    return `
      display: flex;
      color: ${SwxTheme.palette.white};
      height: 100vh;
      background: ${SwxTheme.palette['secondary-dark']} url(/shapes-lines-large.svg);
      background-repeat: no-repeat;
      background-position: calc(50% - 257px) calc(50% - 214px);
    `
  },
  subContainer: () => {
    return `
      align-items: center;
      margin: auto;
      width: 30%;
      padding-bottom: 120px;
      overflow: visible;
      height: 200px;
    `
  },
  logo: () => {
    return `
      top: 20vh;
      left: 11vw;
      position: absolute;
      display: flex;
      align-items: center;
      img {
        height: 52px;
        width: 47px;
        margin-right: 20px;
      }
    `
  },
  statusTitle: (SwxTheme) => {
    return `
      color: ${SwxTheme.palette.primary};
      font-size: 20px;
      padding-bottom: 16px;
    `
  },
  description: (SwxTheme) => {
    return `
      overflow:visible;
      margin-bottom: 40px;
      color: ${SwxTheme.palette.white};
    `
  },
  link: (SwxTheme) => {
    return `
      text-decoration: none;
      color: ${SwxTheme.palette.primary};
      cursor: pointer;
    `
  }
}

export default styles
